import countdown from "../countdown"

export default (getView) => (nextStepPath, timeoutSeconds) => ({
  ...getView(nextStepPath),
  ...countdown(timeoutSeconds),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.initCountdown()
    this.store.restorePurchasedBasicOffer()
  },

  scrollToOffers() {
    document
      .getElementById("offers")
      .scrollIntoView({ behavior: "smooth", block: "center", inline: "center" })
  },
})
